export const HKDSE_MATHS_MC_2015 = {
    year: 2015,
    title: "HKDSE 數學科 多項選擇題 2015 (Part 1)",
    totalQuestions: 45,
    timeLimit: 120, // minutes
    questions: [
      {
        id: "2015Q001",
        questionNumber: 1,
        question: "$(x+1)(x^2+x+1) =$",
        options: [
          { id: "A", text: "$x^3+1$" },
          { id: "B", text: "$(x+1)^3$" },
          { id: "C", text: "$x^3+x^2+x+1$" },
          { id: "D", text: "$x^3+2x^2+2x+1$" }
        ],
        correctAnswer: "C",
        solution: "$(x+1)(x^2+x+1) = x(x^2+x+1) + 1(x^2+x+1) = x^3+x^2+x+x^2+x+1 = x^3+2x^2+2x+1$",
        topic: "多項式乘法",
        difficulty: "基礎"
      },
      {
        id: "2015Q002",
        questionNumber: 2,
        question: "$\\frac{(3y^6)^4}{3y^2} =$",
        options: [
          { id: "A", text: "$4y^5$" },
          { id: "B", text: "$4y^8$" },
          { id: "C", text: "$27y^{12}$" },
          { id: "D", text: "$27y^{22}$" }
        ],
        correctAnswer: "D",
        solution: "$\\frac{(3y^6)^4}{3y^2} = \\frac{3^4y^{24}}{3y^2} = 3^3y^{22} = 27y^{22}$",
        topic: "指數",
        difficulty: "基礎"
      },
      {
        id: "2015Q003",
        questionNumber: 3,
        question: "若 $p+3q=4$ 及 $5p+9q=2$，則 $p=$",
        options: [
          { id: "A", text: "$-5$" },
          { id: "B", text: "$-3$" },
          { id: "C", text: "$3$" },
          { id: "D", text: "$5$" }
        ],
        correctAnswer: "A",
        solution: "$p+3q=4$\\n$5p+9q=2$\\n$3p+9q=12$（第一式乘以3）\\n$5p+9q=2$\\n相減：$-2p=10$\\n$p=-5$",
        topic: "聯立方程",
        difficulty: "基礎"
      },
      {
        id: "2015Q004",
        questionNumber: 4,
        question: "$0.0023456789=$",
        options: [
          { id: "A", text: "$0.00235$ (準確至六位小數)" },
          { id: "B", text: "$0.002345$ (準確至六位小數)" },
          { id: "C", text: "$0.002346$ (準確至六位有效數字)" },
          { id: "D", text: "$0.00234568$ (準確至八位有效數字)" }
        ],
        correctAnswer: "C",
        solution: "$0.0023456789$ 準確至六位有效數字為 $0.002346$",
        topic: "近似值",
        difficulty: "基礎"
      },
      {
        id: "2015Q005",
        questionNumber: 5,
        question: "若 $m$ 及 $n$ 均為常數使得 $x^2+mx+n \\equiv (x+4)(x-m)+6$，則 $n=$",
        options: [
          { id: "A", text: "$-8$" },
          { id: "B", text: "$-2$" },
          { id: "C", text: "$2$" },
          { id: "D", text: "$6$" }
        ],
        correctAnswer: "B",
        solution: "$(x+4)(x-m)+6 = x^2-mx+4x-4m+6 = x^2+(4-m)x+(6-4m)$\\n比較係數：$m = 4-m$ 及 $n = 6-4m$\\n$m = 2$\\n$n = 6-4(2) = -2$",
        topic: "恆等式",
        difficulty: "中等"
      },
      {
        id: "2015Q006",
        questionNumber: 6,
        question: "$18+7x>4$ 或 $5-2x<3$ 的解為",
        options: [
          { id: "A", text: "$x>-2$" },
          { id: "B", text: "$x>-1$" },
          { id: "C", text: "$x>1$" },
          { id: "D", text: "$-2<x<1$" }
        ],
        correctAnswer: "A",
        solution: "$18+7x>4$ 得 $7x>-14$，即 $x>-2$\\n$5-2x<3$ 得 $-2x<-2$，即 $x>1$\\n取聯集：$x>-2$",
        topic: "不等式",
        difficulty: "基礎"
      },
      {
        id: "2015Q007",
        questionNumber: 7,
        question: "若 $\\beta$ 為方程 $4x^2-5x-1=0$ 的根，則 $7+10\\beta-8\\beta^2=$",
        options: [
          { id: "A", text: "$5$" },
          { id: "B", text: "$7$" },
          { id: "C", text: "$9$" },
          { id: "D", text: "$11$" }
        ],
        correctAnswer: "C",
        solution: "$4\\beta^2-5\\beta-1=0$\\n$4\\beta^2=5\\beta+1$\\n$8\\beta^2=10\\beta+2$\\n$7+10\\beta-8\\beta^2 = 7+10\\beta-(10\\beta+2) = 7-2 = 5$",
        topic: "二次方程",
        difficulty: "中等"
      },
      {
        id: "2015Q008",
        questionNumber: 8,
        question: "圖中所示為 $y=a(x+b)^2$ 的圖像，其中 $a$ 及 $b$ 均為常數。下列何者正確？",
        options: [
          { id: "A", text: "$a<0$ 及 $b<0$" },
          { id: "B", text: "$a<0$ 及 $b>0$" },
          { id: "C", text: "$a>0$ 及 $b<0$" },
          { id: "D", text: "$a>0$ 及 $b>0$" }
        ],
        correctAnswer: "C",
        solution: "拋物線開口向上，所以 $a>0$\\n頂點在 $x$ 軸左方，所以 $b<0$",
        topic: "二次函數",
        difficulty: "中等"
      },
      {
        id: "2015Q009",
        questionNumber: 9,
        question: "若某紀念品的價錢增加 $70%$ 且隨後減少 $60%$，求該紀念品的價錢改變的百分數。",
        options: [
          { id: "A", text: "$-58%$" },
          { id: "B", text: "$-32%$" },
          { id: "C", text: "$2%$" },
          { id: "D", text: "$10%$" }
        ],
        correctAnswer: "B",
        solution: "設原價為 $100$\\n增加 $70%$ 後：$100 \\times 1.7 = 170$\\n減少 $60%$ 後：$170 \\times 0.4 = 68$\\n改變百分數：$\\frac{68-100}{100} \\times 100% = -32%$",
        topic: "百分比",
        difficulty: "中等"
      },
      {
        id: "2015Q010",
        questionNumber: 10,
        question: "存款 $$50000$，年利率 $6%$，年期 $3$ 年，複利計算，每季一結。求本利和準確至最接近的元。",
        options: [
          { id: "A", text: "$$59000$" },
          { id: "B", text: "$$59551$" },
          { id: "C", text: "$$59755$" },
          { id: "D", text: "$$59781$" }
        ],
        correctAnswer: "D",
        solution: "每季利率 $= \\frac{6%}{4} = 1.5%$\\n期數 $= 3 \\times 4 = 12$\\n本利和 $= 50000 \\times (1.015)^{12} \\approx 59781$",
        topic: "複利",
        difficulty: "中等"
      },
      {
        id: "2015Q011",
        questionNumber: 11,
        question: "設 $a$、$b$ 及 $c$ 均為非零的數。若 $a:c = 5:3$ 及 $b:c = 3:2$，則 $(a+c):(b+c) =$",
        options: [
          { id: "A", text: "$7:5$" },
          { id: "B", text: "$8:5$" },
          { id: "C", text: "$16:15$" },
          { id: "D", text: "$19:15$" }
        ],
        correctAnswer: "B",
        solution: "設 $c = 6k$\\n$a:c = 5:3$，所以 $a = 10k$\\n$b:c = 3:2$，所以 $b = 9k$\\n$(a+c):(b+c) = (10k+6k):(9k+6k) = 16k:15k = 16:15$",
        topic: "比例",
        difficulty: "中等"
      },
      {
        id: "2015Q012",
        questionNumber: 12,
        question: "已知 $z$ 隨 $x^3$ 及 $y^2$ 正變。當 $x=2$ 及 $y=1$ 時，$z=14$。當 $x=3$ 及 $y=-2$ 時，$z=$",
        options: [
          { id: "A", text: "$-189$" },
          { id: "B", text: "$-126$" },
          { id: "C", text: "$126$" },
          { id: "D", text: "$189$" }
        ],
        correctAnswer: "D",
        solution: "$z = kx^3y^2$\\n當 $x=2$，$y=1$ 時：$14 = k(2^3)(1^2) = 8k$\\n$k = \\frac{7}{4}$\\n當 $x=3$，$y=-2$ 時：$z = \\frac{7}{4}(3^3)(-2)^2 = \\frac{7}{4}(27)(4) = 189$",
        topic: "變分",
        difficulty: "中等"
      },
      {
        id: "2015Q013",
        questionNumber: 13,
        question: "圖中，第 $1$ 個圖案包含 $5$ 粒點子。對任意正整數 $n$，第 $(n+1)$ 個圖案是由第 $n$ 個圖案加上 $4$ 粒點子所組成。求第 $6$ 個圖案的點子數目。",
        options: [
          { id: "A", text: "$21$" },
          { id: "B", text: "$25$" },
          { id: "C", text: "$29$" },
          { id: "D", text: "$33$" }
        ],
        correctAnswer: "B",
        solution: "第 $n$ 個圖案的點子數目 $= 5 + 4(n-1) = 4n + 1$\\n第 $6$ 個圖案：$4(6) + 1 = 25$",
        topic: "數列",
        difficulty: "基礎"
      },
      {
        id: "2015Q014",
        questionNumber: 14,
        question: "現有砂糖一袋。該袋內砂糖的重量量得 $5$ kg 準確至最接近的 kg。若將該袋砂糖包裝成 $n$ 包使每包內砂糖的重量均量得 $10$ g 準確至最接近的 g，求 $n$ 的最大可取值。",
        options: [
          { id: "A", text: "$429$" },
          { id: "B", text: "$500$" },
          { id: "C", text: "$578$" },
          { id: "D", text: "$579$" }
        ],
        correctAnswer: "B",
        solution: "砂糖重量範圍：$4.5 \\leq w < 5.5$ kg\\n每包重量範圍：$9.5 \\leq p < 10.5$ g\\n最大包數 $= \\frac{4500}{10.5} \\approx 428.57$\\n因此最大可取值為 $428$",
        topic: "誤差",
        difficulty: "困難"
      },
      {
        id: "2015Q015",
        questionNumber: 15,
        question: "圖中，$N$ 為 $AC$ 上的一點且 $E$ 為 $DN$ 上的一點。若 $DN = 6$ cm 及 $EN = 5$ cm，則 $\\triangle ABC$ 的面積為",
        options: [
          { id: "A", text: "$24 \\text{ cm}^2$" },
          { id: "B", text: "$30 \\text{ cm}^2$" },
          { id: "C", text: "$96 \\text{ cm}^2$" },
          { id: "D", text: "$192 \\text{ cm}^2$" }
        ],
        correctAnswer: "C",
        solution: "$DE = DN - EN = 6 - 5 = 1$ cm\\n$\\triangle ABC$ 的面積 $= \\frac{1}{2} \\times AB \\times BC = \\frac{1}{2} \\times 13 \\times 16 = 104$ cm$^2$",
        topic: "面積",
        difficulty: "中等"
      },
      {
        id: "2015Q016",
        questionNumber: 16,
        question: "一直立圓錐體的高及底半徑分別為 $12$ cm 及 $9$ cm。圖中所示的平截頭體是從該圓錐體切去其上部分而成。該平截頭體的高為 $8$ cm。求該平截頭體的體積。",
        options: [
          { id: "A", text: "$210\\pi \\text{ cm}^3$" },
          { id: "B", text: "$312\\pi \\text{ cm}^3$" },
          { id: "C", text: "$324\\pi \\text{ cm}^3$" },
          { id: "D", text: "$936\\pi \\text{ cm}^3$" }
        ],
        correctAnswer: "B",
        solution: "原圓錐體體積 $= \\frac{1}{3}\\pi(9)^2(12) = 324\\pi$\\n切去部分的高 $= 12 - 8 = 4$ cm\\n切去部分的半徑 $= 9 \\times \\frac{4}{12} = 3$ cm\\n切去部分的體積 $= \\frac{1}{3}\\pi(3)^2(4) = 12\\pi$\\n平截頭體體積 $= 324\\pi - 12\\pi = 312\\pi$",
        topic: "立體幾何",
        difficulty: "困難"
      },
      {
        id: "2015Q017",
        questionNumber: 17,
        question: "圖中，$ABCD$ 為一平行四邊形。$E$ 為 $CD$ 上的一點使得 $DE:EC = 2:3$。$AD$ 的延線與 $BE$ 的延線相交於 $F$，而 $AE$ 的延線與 $BC$ 的延線相交於 $G$。若 $\\triangle DEF$ 的面積為 $8 \\text{ cm}^2$，則 $\\triangle CEG$ 的面積為",
        options: [
          { id: "A", text: "$12 \\text{ cm}^2$" },
          { id: "B", text: "$18 \\text{ cm}^2$" },
          { id: "C", text: "$20 \\text{ cm}^2$" },
          { id: "D", text: "$27 \\text{ cm}^2$" }
        ],
        correctAnswer: "D",
        solution: "$DE:EC = 2:3$\\n$\\triangle DEF$ 與 $\\triangle CEG$ 相似\\n面積比 $= (\\frac{DE}{EC})^2 = (\\frac{2}{3})^2 = \\frac{4}{9}$\\n$\\triangle CEG$ 的面積 $= 8 \\times \\frac{9}{4} = 18$",
        topic: "相似三角形",
        difficulty: "困難"
      },
      {
        id: "2015Q018",
        questionNumber: 18,
        question: "圖中，$\\frac{AD}{AB} =$",
        options: [
          { id: "A", text: "$\\cos\\alpha \\tan\\beta$" },
          { id: "B", text: "$\\sin\\alpha \\tan\\beta$" },
          { id: "C", text: "$\\frac{\\cos\\alpha}{\\tan\\beta}$" },
          { id: "D", text: "$\\frac{\\sin\\alpha}{\\tan\\beta}$" }
        ],
        correctAnswer: "A",
        solution: "$\\frac{AD}{AB} = \\frac{AD}{AC} \\times \\frac{AC}{AB} = \\cos\\alpha \\times \\tan\\beta = \\cos\\alpha \\tan\\beta$",
        topic: "三角學",
        difficulty: "中等"
      },
      {
        id: "2015Q019",
        questionNumber: 19,
        question: "$\\frac{\\cos 180°}{1 + \\sin(90° + \\theta)} + \\frac{\\cos 360°}{1 + \\sin(270° + \\theta)} =$",
        options: [
          { id: "A", text: "$0$" },
          { id: "B", text: "$\\frac{2}{\\cos\\theta}$" },
          { id: "C", text: "$\\frac{2\\cos\\theta}{\\sin^2\\theta}$" },
          { id: "D", text: "$\\frac{2\\sin\\theta}{\\cos^2\\theta}$" }
        ],
        correctAnswer: "A",
        solution: "$\\cos 180° = -1$，$\\cos 360° = 1$\\n$\\sin(90° + \\theta) = \\cos\\theta$\\n$\\sin(270° + \\theta) = -\\cos\\theta$\\n原式 $= \\frac{-1}{1 + \\cos\\theta} + \\frac{1}{1 - \\cos\\theta} = 0$",
        topic: "三角學",
        difficulty: "困難"
      },
      {
        id: "2015Q020",
        questionNumber: 20,
        question: "圖中，$AD$ 為圓 $ABCDE$ 的一直徑。若 $\\angle BAD = 58°$ 及 $BC = CD$，則 $\\angle AEC =$",
        options: [
          { id: "A", text: "$32°$" },
          { id: "B", text: "$58°$" },
          { id: "C", text: "$61°$" },
          { id: "D", text: "$64°$" }
        ],
        correctAnswer: "C",
        solution: "$\\angle BAD = 58°$\\n$\\angle BCD = 180° - 58° = 122°$\\n$BC = CD$，所以 $\\angle BDC = \\angle CBD = 29°$\\n$\\angle AEC = 180° - 29° - 90° = 61°$",
        topic: "圓",
        difficulty: "困難"
      },
      {
        id: "2015Q021",
        questionNumber: 21,
        question: "圓 $ABCD$ 的直徑 $AC$ 與直徑 $BD$ 相交於點 $E$。若 $\\angle AEB = 90°$ 及 $AC = 24$ cm，則 $\\triangle AEB$ 的面積為",
        options: [
          { id: "A", text: "$41 \\text{ cm}^2$" },
          { id: "B", text: "$72 \\text{ cm}^2$" },
          { id: "C", text: "$144 \\text{ cm}^2$" },
          { id: "D", text: "$288 \\text{ cm}^2$" }
        ],
        correctAnswer: "B",
        solution: "$AC = 24$ cm，所以半徑 $= 12$ cm\\n$AE = BE = 12$ cm（半徑）\\n$\\triangle AEB$ 的面積 $= \\frac{1}{2} \\times 12 \\times 12 = 72$ cm$^2$",
        topic: "圓",
        difficulty: "中等"
      },
      {
        id: "2015Q022",
        questionNumber: 22,
        question: "若某正多邊形的一內角為該多邊形的一外角的 $5$ 倍，則下列何者正確？\\nI. 該多邊形的每一內角均為 $150°$。\\nII. 該多邊形的對角線數目為 $6$。\\nIII. 該多邊形的旋轉對稱的折式數目為 $6$。",
        options: [
          { id: "A", text: "只有 I" },
          { id: "B", text: "只有 II" },
          { id: "C", text: "只有 I 及 III" },
          { id: "D", text: "只有 II 及 III" }
        ],
        correctAnswer: "C",
        solution: "內角 $+$ 外角 $= 180°$\\n內角 $= 5 \\times$ 外角\\n$6 \\times$ 外角 $= 180°$\\n外角 $= 30°$，內角 $= 150°$\\n邊數 $= \\frac{360°}{30°} = 12$\\n對角線數目 $= \\frac{12(12-3)}{2} = 54$",
        topic: "多邊形",
        difficulty: "困難"
      },
      {
        id: "2015Q023",
        questionNumber: 23,
        question: "點 $A$ 的直角坐標為 $(\\sqrt{3}, -1)$。若 $A$ 對 $y$ 軸作反射，則它的像的極坐標為",
        options: [
          { id: "A", text: "$(1, 210°)$" },
          { id: "B", text: "$(1, 240°)$" },
          { id: "C", text: "$(2, 210°)$" },
          { id: "D", text: "$(2, 240°)$" }
        ],
        correctAnswer: "C",
        solution: "反射後的坐標為 $(-\\sqrt{3}, -1)$\\n極坐標：$r = \\sqrt{(-\\sqrt{3})^2 + (-1)^2} = 2$\\n$\\theta = 210°$",
        topic: "坐標幾何",
        difficulty: "中等"
      },
      {
        id: "2015Q024",
        questionNumber: 24,
        question: "點 $A$ 及點 $B$ 的坐標分別為 $(2, 0)$ 及 $(1, 5)$。若 $P$ 為直角坐標平面上的一動點使得 $P$ 與 $A$ 及 $B$ 等距，則 $P$ 的軌跡是",
        options: [
          { id: "A", text: "$AB$ 的垂直平分線。" },
          { id: "B", text: "以 $AB$ 為一直徑的圓。" },
          { id: "C", text: "通過 $A$ 及 $B$ 的直線。" },
          { id: "D", text: "$\\angle AOB$ 的角平分線，其中 $O$ 為原點。" }
        ],
        correctAnswer: "A",
        solution: "$P$ 與 $A$ 及 $B$ 等距，即 $PA = PB$\\n這表示 $P$ 在 $AB$ 的垂直平分線上",
        topic: "軌跡",
        difficulty: "中等"
      },
      {
        id: "2015Q025",
        questionNumber: 25,
        question: "圖中，直線 $L_1$ 及直線 $L_2$ 的方程分別為 $ax = 1$ 及 $bx + cy = 1$。下列何者正確？\\nI. $a < 0$\\nII. $a < b$\\nIII. $c > 0$",
        options: [
          { id: "A", text: "只有 I 及 II" },
          { id: "B", text: "只有 I 及 III" },
          { id: "C", text: "只有 II 及 III" },
          { id: "D", text: "I、II 及 III" }
        ],
        correctAnswer: "B",
        solution: "$L_1$ 是垂直線，$a < 0$（在 $y$ 軸左方）\\n$L_2$ 有正斜率，所以 $c > 0$\\n$a$ 和 $b$ 的關係無法確定",
        topic: "直線方程",
        difficulty: "中等"
      },
      {
        id: "2015Q026",
        questionNumber: 26,
        question: "圓 $C$ 通過點 $(0, 3)$。若 $C$ 的圓心的坐標為 $(-4, 3)$，則 $C$ 的方程為",
        options: [
          { id: "A", text: "$x^2 + y^2 - 8x + 6y + 9 = 0$" },
          { id: "B", text: "$x^2 + y^2 - 8x + 6y + 16 = 0$" },
          { id: "C", text: "$x^2 + y^2 + 8x - 6y + 9 = 0$" },
          { id: "D", text: "$x^2 + y^2 + 8x - 6y + 16 = 0$" }
        ],
        correctAnswer: "C",
        solution: "圓心 $(-4, 3)$，半徑 $= \\sqrt{(-4-0)^2 + (3-3)^2} = 4$\\n圓的方程：$(x+4)^2 + (y-3)^2 = 16$\\n$x^2 + 8x + 16 + y^2 - 6y + 9 = 16$\\n$x^2 + y^2 + 8x - 6y + 9 = 0$",
        topic: "圓",
        difficulty: "中等"
      },
      {
        id: "2015Q027",
        questionNumber: 27,
        question: "在某遊戲中投擲兩枚公平骰子。若所擲得的兩數之和為 $7$，賭贏得 $$56$；否則，賭贏得 $$6$。求在該遊戲中所贏得的金額的期望值。",
        options: [
          { id: "A", text: "$$11$" },
          { id: "B", text: "$$12$" },
          { id: "C", text: "$$30$" },
          { id: "D", text: "$$31$" }
        ],
        correctAnswer: "A",
        solution: "兩數之和為 $7$ 的概率 $= \\frac{6}{36} = \\frac{1}{6}$\\n其他情況的概率 $= \\frac{5}{6}$\\n期望值 $= 56 \\times \\frac{1}{6} + 6 \\times \\frac{5}{6} = \\frac{56}{6} + \\frac{30}{6} = \\frac{86}{6} \\approx 14.33$",
        topic: "概率",
        difficulty: "中等"
      },
      {
        id: "2015Q028",
        questionNumber: 28,
        question: "下面的棒形圖顯示某班學生擁有鑰匙的數目的分佈。求從該班中隨機選出一名學生擁有 $3$ 條鑰匙的機率。",
        options: [
          { id: "A", text: "$\\frac{1}{5}$" },
          { id: "B", text: "$\\frac{2}{11}$" },
          { id: "C", text: "$\\frac{4}{11}$" },
          { id: "D", text: "$\\frac{9}{11}$" }
        ],
        correctAnswer: "B",
        solution: "總學生人數 $= 12 + 16 + 8 + 4 + 4 = 44$\\n擁有 $3$ 條鑰匙的學生人數 $= 8$\\n機率 $= \\frac{8}{44} = \\frac{2}{11}$",
        topic: "概率",
        difficulty: "基礎"
      },
      {
        id: "2015Q029",
        questionNumber: 29,
        question: "下面的框線圖顯示在某學期一些教師的閱書數目的分佈。求該分佈的四分位數間距。",
        options: [
          { id: "A", text: "$20$" },
          { id: "B", text: "$35$" },
          { id: "C", text: "$40$" },
          { id: "D", text: "$45$" }
        ],
        correctAnswer: "C",
        solution: "四分位數間距 $= Q_3 - Q_1$\\n從框線圖讀取：$Q_1 = 25$，$Q_3 = 65$\\n四分位數間距 $= 65 - 25 = 40$",
        topic: "統計",
        difficulty: "中等"
      },
      {
        id: "2015Q030",
        questionNumber: 30,
        question: "考慮以下整數：\\n$2 \\quad 2 \\quad 3 \\quad 3 \\quad 3 \\quad 3 \\quad 3 \\quad 5 \\quad 5 \\quad 6 \\quad 8 \\quad 8 \\quad 9 \\quad 10 \\quad m$\\n設 $p$、$q$ 及 $r$ 分別為以上整數的平均值、中位數及眾數。若 $3 \\leq m \\leq 5$，則下列何者必為正確？\\nI. $p > q$\\nII. $p > r$\\nIII. $q > r$",
        options: [
          { id: "A", text: "只有 I" },
          { id: "B", text: "只有 II" },
          { id: "C", text: "只有 I 及 III" },
          { id: "D", text: "只有 II 及 III" }
        ],
        correctAnswer: "D",
        solution: "眾數 $r = 3$（出現最多次）\\n中位數 $q = 3$（第 $8$ 個數）\\n平均值 $p > 3$（因為有較大的數）\\n因此 $p > r$ 及 $q = r$",
        topic: "統計",
        difficulty: "中等"
      },
      {
        id: "2015Q031",
        questionNumber: 31,
        question: "$\\frac{1}{x^2 - 2x + 1} - \\frac{1}{x^2 + x - 2} =$",
        options: [
          { id: "A", text: "$\\frac{1}{(x-1)(x+2)}$" },
          { id: "B", text: "$\\frac{1}{(x-1)^2(x+2)}$" },
          { id: "C", text: "$\\frac{3}{(x-1)^2(x+2)}$" },
          { id: "D", text: "$\\frac{2x+1}{(x-1)^2(x+2)}$" }
        ],
        correctAnswer: "D",
        solution: "$\\frac{1}{(x-1)^2} - \\frac{1}{(x-1)(x+2)}$\\n$= \\frac{x+2}{(x-1)^2(x+2)} - \\frac{x-1}{(x-1)^2(x+2)}$\\n$= \\frac{x+2-x+1}{(x-1)^2(x+2)} = \\frac{3}{(x-1)^2(x+2)}$",
        topic: "分式運算",
        difficulty: "中等"
      },
      {
        id: "2015Q032",
        questionNumber: 32,
        question: "圖中的圖像顯示 $\\log_3 x$ 與 $\\log_3 y$ 之間的線性關係。下列何者必為正確？",
        options: [
          { id: "A", text: "$x^2 y^3 = 729$" },
          { id: "B", text: "$x^3 y^2 = 729$" },
          { id: "C", text: "$x^2 + y^3 = 729$" },
          { id: "D", text: "$x^3 + y^2 = 729$" }
        ],
        correctAnswer: "A",
        solution: "線性關係：$\\log_3 y = m\\log_3 x + c$\\n$y = 3^{m\\log_3 x + c} = 3^c \\times x^m$\\n從圖像讀取：$m = -\\frac{2}{3}$\\n$y = 3^c \\times x^{-\\frac{2}{3}}$\\n$x^2 y^3 = x^2 \\times (3^c \\times x^{-\\frac{2}{3}})^3 = x^2 \\times 3^{3c} \\times x^{-2} = 3^{3c} = 729$",
        topic: "對數",
        difficulty: "困難"
      },
      {
        id: "2015Q033",
        questionNumber: 33,
        question: "$11 + 2^6 + 2^{10} + 2^{11} =$",
        options: [
          { id: "A", text: "$11000100101_2$" },
          { id: "B", text: "$11010010001_2$" },
          { id: "C", text: "$11000010101_2$" },
          { id: "D", text: "$11010010001_2$" }
        ],
        correctAnswer: "A",
        solution: "$11 + 2^6 + 2^{10} + 2^{11} = 11 + 64 + 1024 + 2048 = 3147$\\n轉換為二進制：$11000100101_2$",
        topic: "數制",
        difficulty: "中等"
      },
      {
        id: "2015Q034",
        questionNumber: 34,
        question: "設 $k$ 為一常數。若二次方程 $x^2 + kx - 2 = 0$ 的根為 $\\alpha$ 及 $\\beta$，則 $\\alpha^2 + \\beta^2 =$",
        options: [
          { id: "A", text: "$k^2$" },
          { id: "B", text: "$k^2 + 4$" },
          { id: "C", text: "$k^2 - 4$" },
          { id: "D", text: "$k^2 - 8$" }
        ],
        correctAnswer: "B",
        solution: "$\\alpha + \\beta = -k$，$\\alpha\\beta = -2$\\n$\\alpha^2 + \\beta^2 = (\\alpha + \\beta)^2 - 2\\alpha\\beta = k^2 - 2(-2) = k^2 + 4$",
        topic: "二次方程",
        difficulty: "中等"
      },
      {
        id: "2015Q035",
        questionNumber: 35,
        question: "設 $z = (a+5)i^6 + (a-3)i^7$，其中 $a$ 為一實數。若 $z$ 為一實數，則 $a =$",
        options: [
          { id: "A", text: "$-5$" },
          { id: "B", text: "$-3$" },
          { id: "C", text: "$3$" },
          { id: "D", text: "$5$" }
        ],
        correctAnswer: "C",
        solution: "$i^6 = -1$，$i^7 = -i$\\n$z = (a+5)(-1) + (a-3)(-i) = -a-5 - (a-3)i$\\n$z$ 為實數，所以虛部為 $0$\\n$-(a-3) = 0$\\n$a = 3$",
        topic: "複數",
        difficulty: "中等"
      },
      {
        id: "2015Q036",
        questionNumber: 36,
        question: "圖中所示為一陰影區域（包括邊界在內）。若 $(a,b)$ 為陰影區域中的一點，則下列何者正確？\\nI. $a \\leq 4$\\nII. $a \\geq b - 5$\\nIII. $a \\geq 10 - 2b$",
        options: [
          { id: "A", text: "只有 I 及 II" },
          { id: "B", text: "只有 I 及 III" },
          { id: "C", text: "只有 II 及 III" },
          { id: "D", text: "I、II 及 III" }
        ],
        correctAnswer: "D",
        solution: "邊界線：$x = 4$，$y = x + 5$，$x + 2y = 10$\\nI. $a \\leq 4$（正確）\\nII. $a \\geq b - 5$（$y \\leq x + 5$）\\nIII. $a \\geq 10 - 2b$（$x + 2y \\leq 10$）",
        topic: "不等式",
        difficulty: "困難"
      },
      {
        id: "2015Q037",
        questionNumber: 37,
        question: "設 $x_n$ 為一等比數列的第 $n$ 項。若 $x_6 = 216$ 及 $x_8 = 96$，則下列何者必為正確？\\nI. $x_3 = 729$\\nII. $\\frac{x_5}{x_7} > 1$\\nIII. $x_2 + x_4 + x_6 + \\cdots + x_{2n} < 2015$",
        options: [
          { id: "A", text: "只有 I" },
          { id: "B", text: "只有 II" },
          { id: "C", text: "只有 I 及 III" },
          { id: "D", text: "只有 II 及 III" }
        ],
        correctAnswer: "B",
        solution: "$x_6 = ar^5 = 216$\\n$x_8 = ar^7 = 96$\\n$r^2 = \\frac{96}{216} = \\frac{4}{9}$\\n$r = \\frac{2}{3}$（遞減數列）\\n$\\frac{x_5}{x_7} = \\frac{ar^4}{ar^6} = \\frac{1}{r^2} = \\frac{9}{4} > 1$",
        topic: "等比數列",
        difficulty: "困難"
      },
      {
        id: "2015Q038",
        questionNumber: 38,
        question: "當 $0° \\leq x < 360°$ 時，方程 $\\cos^2 x - \\sin x = 1$ 有多少個根？",
        options: [
          { id: "A", text: "$2$" },
          { id: "B", text: "$3$" },
          { id: "C", text: "$4$" },
          { id: "D", text: "$5$" }
        ],
        correctAnswer: "C",
        solution: "$\\cos^2 x - \\sin x = 1$\\n$1 - \\sin^2 x - \\sin x = 1$\\n$\\sin^2 x + \\sin x = 0$\\n$\\sin x(\\sin x + 1) = 0$\\n$\\sin x = 0$ 或 $\\sin x = -1$\\n$\\sin x = 0$ 在 $[0°, 360°)$ 有 $2$ 個根\\n$\\sin x = -1$ 在 $[0°, 360°)$ 有 $1$ 個根\\n總共 $3$ 個根",
        topic: "三角方程",
        difficulty: "中等"
      },
      {
        id: "2015Q039",
        questionNumber: 39,
        question: "設 $k$ 為一正常數且 $-180° < \\theta < 180°$。若圖中所示為 $y = \\sin(kx° + \\theta)$ 的圖像，則",
        options: [
          { id: "A", text: "$k = \\frac{1}{2}$ 及 $\\theta = -30°$" },
          { id: "B", text: "$k = \\frac{1}{2}$ 及 $\\theta = 30°$" },
          { id: "C", text: "$k = 2$ 及 $\\theta = -30°$" },
          { id: "D", text: "$k = 2$ 及 $\\theta = 30°$" }
        ],
        correctAnswer: "A",
        solution: "週期 $= \\frac{360°}{k} = 720°$（從圖像讀取）\\n$k = \\frac{1}{2}$\\n相位移動 $= -30°$\\n$\\theta = -30°$",
        topic: "三角函數",
        difficulty: "困難"
      },
      {
        id: "2015Q040",
        questionNumber: 40,
        question: "圖中，$AB$ 及 $AC$ 分別為圓在 $B$ 及 $C$ 的切線。$BD$ 為該圓的一直徑。$AC$ 的延線與 $BD$ 的延線相交於 $E$。若 $AB = 6$ cm 及 $AE = 10$ cm，則 $BD =$",
        options: [
          { id: "A", text: "$3$ cm" },
          { id: "B", text: "$5$ cm" },
          { id: "C", text: "$6$ cm" },
          { id: "D", text: "$8$ cm" }
        ],
        correctAnswer: "C",
        solution: "$AB = AC = 6$ cm（切線性質）\\n$CE = AE - AC = 10 - 6 = 4$ cm\\n$CE \\times AE = BE \\times DE$（割線定理）\\n$4 \\times 10 = BE \\times DE$\\n$BE \\times DE = 40$\\n$BD = BE + DE = 6$ cm",
        topic: "圓",
        difficulty: "困難"
      },
      {
        id: "2015Q041",
        questionNumber: 41,
        question: "求常數 $k$ 使得圓 $x^2 + y^2 + 2x - 6y + k = 0$ 與直線 $x + y + 4 = 0$ 只相交於一點。",
        options: [
          { id: "A", text: "$-16$" },
          { id: "B", text: "$-8$" },
          { id: "C", text: "$8$" },
          { id: "D", text: "$16$" }
        ],
        correctAnswer: "C",
        solution: "圓心 $(-1, 3)$，半徑 $= \\sqrt{1 + 9 - k} = \\sqrt{10 - k}$\\n直線到圓心的距離 $= \\frac{|-1 + 3 + 4|}{\\sqrt{2}} = \\frac{6}{\\sqrt{2}} = 3\\sqrt{2}$\\n相切時：$3\\sqrt{2} = \\sqrt{10 - k}$\\n$18 = 10 - k$\\n$k = -8$",
        topic: "圓與直線",
        difficulty: "困難"
      },
      {
        id: "2015Q042",
        questionNumber: 42,
        question: "設 $O$ 為原點。點 $P$ 及點 $Q$ 的坐標分別為 $(0, 60)$ 及 $(96, 48)$。$\\triangle OPQ$ 的垂心的 $x$ 坐標為",
        options: [
          { id: "A", text: "$6$" },
          { id: "B", text: "$32$" },
          { id: "C", text: "$45$" },
          { id: "D", text: "$48$" }
        ],
        correctAnswer: "D",
        solution: "垂心是三角形三條高的交點\\n$OP$ 的斜率 $= \\infty$（垂直線）\\n$OQ$ 的斜率 $= \\frac{48}{96} = \\frac{1}{2}$\\n垂心的 $x$ 坐標 $= 48$",
        topic: "坐標幾何",
        difficulty: "困難"
      },
      {
        id: "2015Q043",
        questionNumber: 43,
        question: "$6$ 名男生與 $2$ 名女生排成一隊。若沒有女生相鄰而排，則可排成多少不同的隊？",
        options: [
          { id: "A", text: "$1440$" },
          { id: "B", text: "$10080$" },
          { id: "C", text: "$30240$" },
          { id: "D", text: "$35280$" }
        ],
        correctAnswer: "C",
        solution: "先排 $6$ 名男生：$6! = 720$\\n在 $7$ 個空隙中選 $2$ 個位置放女生：$C_2^7 = 21$\\n$2$ 名女生的排列：$2! = 2$\\n總方法：$720 \\times 21 \\times 2 = 30240$",
        topic: "排列組合",
        difficulty: "困難"
      },
      {
        id: "2015Q044",
        questionNumber: 44,
        question: "$P$ 袋內有 $2$ 個紅球及 $4$ 個綠球，而 $Q$ 袋內有 $1$ 個紅球及 $3$ 個綠球。若隨機選取一袋且隨後從該袋中隨機抽出一個球，求抽出綠球的機率。",
        options: [
          { id: "A", text: "$\\frac{3}{10}$" },
          { id: "B", text: "$\\frac{7}{10}$" },
          { id: "C", text: "$\\frac{7}{24}$" },
          { id: "D", text: "$\\frac{17}{24}$" }
        ],
        correctAnswer: "D",
        solution: "選 $P$ 袋的機率 $= \\frac{1}{2}$，從 $P$ 袋抽出綠球的機率 $= \\frac{4}{6} = \\frac{2}{3}$\\n選 $Q$ 袋的機率 $= \\frac{1}{2}$，從 $Q$ 袋抽出綠球的機率 $= \\frac{3}{4}$\\n總機率 $= \\frac{1}{2} \\times \\frac{2}{3} + \\frac{1}{2} \\times \\frac{3}{4} = \\frac{1}{3} + \\frac{3}{8} = \\frac{17}{24}$",
        topic: "概率",
        difficulty: "中等"
      },
      {
        id: "2015Q045",
        questionNumber: 45,
        question: "設 $x_1$、$y_1$ 及 $z_1$ 分別為某組數 ${a_1, a_2, a_3, \\ldots, a_{50}}$ 的平均值、中位數及方差，而 $x_2$、$y_2$ 及 $z_2$ 分別為 ${a_1, a_2, a_3, \\ldots, a_{49}}$ 這組數的平均值、中位數及方差。若 $x_1 = a_{50}$，則下列何者必為正確？\\nI. $x_1 = x_2$\\nII. $y_1 \\geq y_2$\\nIII. $z_1 \\leq z_2$",
        options: [
          { id: "A", text: "只有 I 及 II" },
          { id: "B", text: "只有 I 及 III" },
          { id: "C", text: "只有 II 及 III" },
          { id: "D", text: "I、II 及 III" }
        ],
        correctAnswer: "C",
        solution: "若 $x_1 = a_{50}$，則 $a_{50}$ 等於前 49 個數的平均值\\nI. 不一定正確\\nII. 正確，加入 $a_{50}$ 後中位數可能增加\\nIII. 正確，加入等於平均值的數不會增加方差",
        topic: "統計",
        difficulty: "困難"
      }
    ],
    topics: [
      "指數",
      "因式分解",
      "恆等式", 
      "二次方程",
      "二次函數",
      "不等式",
      "函數",
      "對數",
      "三角函數",
      "三角方程",
      "立體幾何",
      "圓",
      "圓與直線",
      "排列組合",
      "統計"
    ],
    statistics: {
      totalAttempts: 0,
      correctAttempts: 0,
      averageScore: 0,
      completionRate: 0
    }
  };